import { Button, useTheme } from "@mui/material";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import { useState } from "react";

export default function FadeoutExpand({children}) {
    const theme = useTheme()
    const [ active, setActive ] = useState(false);
    const handleExpandClick = () => {
        setActive(!active); 
    }
    const defaultHeight = 150;
    return (
        <>
            <div style={{
                WebkitMaskImage: !active && `linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 100%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                overflow: "hidden",
                height: active ? "fit-content" : defaultHeight,
                transition: "height 0.3s ease-in-out",
            }}>
                {children}
            </div>
            <div style={{textAlign: "center", marginTop: 10}}>
                <Button
                    endIcon={active ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
                    sx={{color: theme.palette.text.primary}}
                    onClick={handleExpandClick}
                >
                    {active ? "Collapse" : "Expand"}
                </Button>
            </div>
        </>
    )
}